package br.com.vvrefeicoes.portal.domain.model

/**
 * Colunas da planilha de "Absenteísmo", na ordem em que aparecem (todas editáveis). Os
 * [aliases] são os cabeçalhos do relatório exportado pelo sistema de ponto.
 */
enum class RhAbsenceColumn(
    override val header: String,
    override val label: String,
    override val aliases: List<String> = emptyList(),
    override val editable: Boolean = true,
) : RhSheetColumn {
    MATRICULA("matricula", "Matrícula", listOf("numero de matricula")),
    NOME("nome", "Nome", listOf("nome do funcionario")),
    CARGO("cargo", "Cargo", listOf("nome do cargo")),
    DEPARTAMENTO("departamento", "Departamento", listOf("nome do departamento")),
    DIRETORA("diretora", "Diretora"),
    GERENTE("gerente", "Gerente"),
    UNIDADE("unidade", "Unidade"),
    CNPJ("cnpj", "CNPJ", listOf("cnpj da empresa")),
    CPF("cpf", "CPF", listOf("cpf do funcionario")),
    ADMISSAO("admissao", "Admissão", listOf("data de admissao do funcionario", "data de admissao")),
    PREVISTO("previsto", "Previsto"),
    TRABALHADO("trabalhado", "Trabalhado"),
    NORMAIS("normais", "Normais"),
    ATRASOS("atrasos", "Atrasos"),
    FALTAS("faltas", "Faltas"),
    AUSENCIA("ausencia", "Ausência"),
    PERCENTUAL_AUSENCIA("% ausencia", "% Ausência", listOf("ausencia %")),
    ;

    override val required: Boolean
        get() = this == PREVISTO
}
